export default "__VITE_ASSET__B4uIV7gJ__"